// Bezpečně přetaví hodnotu z API na pole — když backend vrátí chybu, null
// nebo něco jiného než seznam, komponenty co po tom volají .map/.find/.filter
// nespadnou, jen dostanou prázdný seznam.
export function pole(x) {
  return Array.isArray(x) ? x : [];
}

// Český formát data DD.MM.YYYY — přijímá "YYYY-MM-DD" i ISO datetime string.
export function formatCzechDate(dateStr) {
  if (!dateStr) return '';
  const datePart = String(dateStr).split('T')[0];
  const parts = datePart.split('-');
  if (parts.length >= 3) {
    const [y, m, d] = parts;
    return `${d.padStart(2, '0')}.${m.padStart(2, '0')}.${y}`;
  }
  return String(dateStr);
}

export function formatCzechDateTime(isoStr) {
  if (!isoStr) return '';
  try {
    const d = new Date(isoStr);
    if (isNaN(d.getTime())) return String(isoStr);
    const pad = n => String(n).padStart(2, '0');
    return `${formatCzechDate(isoStr)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  } catch { return String(isoStr); }
}

// "1,5 h (90 min)" — zobrazení odpracovaného času v hodinách i minutách.
export function formatCasHod(hodiny) {
  if (hodiny === null || hodiny === undefined || hodiny === '') return '—';
  const h = parseFloat(hodiny);
  if (isNaN(h)) return '—';
  const totalMin = Math.round(h * 60);
  const hStr = h.toString().replace('.', ',');
  return `${hStr} h (${totalMin} min)`;
}

// Předpřipravené možnosti pro výběr času (v minutách) — používá se ve
// formulářích místo number inputu, aby šlo zadávat čas po 5 minutách.
export const CASOVE_MOZNOSTI_MIN = [
  5, 10, 15, 20, 25, 30, 45, 60, 75, 90, 105, 120, 150, 180, 210, 240, 300, 360, 420, 480,
];

// Minuty -> hodnota v hodinách uložená do DB (zaokrouhleno na 4 des. místa, např. 0.0833).
export function casMinutyNaHodiny(min) {
  return Math.round((min / 60) * 10000) / 10000;
}

// "0 h 5 min", "1 h 30 min" — popisek volby v selectu.
export function casOptionLabel(min) {
  const h = Math.floor(min / 60);
  const m = min % 60;
  return `${h} h ${m} min`;
}

// Rozdíl dvou časů v milisekundách -> "1 d 2 h 30 min".
export function formatDobaReseni(ms) {
  if (ms === null || ms === undefined || isNaN(ms) || ms < 0) return null;
  const totalMin = Math.round(ms / 60000);
  const dny = Math.floor(totalMin / 1440);
  const hod = Math.floor((totalMin % 1440) / 60);
  const min = totalMin % 60;
  const parts = [];
  if (dny > 0) parts.push(`${dny} d`);
  if (dny > 0 || hod > 0) parts.push(`${hod} h`);
  parts.push(`${min} min`);
  return parts.join(' ');
}

// "0h 30min" — kompaktní formát pro řádkový výpis cest a konzultací.
export function formatHM(hodiny) {
  const h = parseFloat(hodiny) || 0;
  const totalMin = Math.round(h * 60);
  const hh = Math.floor(totalMin / 60);
  const mm = totalMin % 60;
  return `${hh}h ${mm}min`;
}

// Počet pracovních dnů (Po–Pá) mezi dvěma daty, ve zlomcích — víkendové
// úseky se nezapočítávají. Používá se pro barevné odlišení SLA v detailu
// tiketu (stejná logika jako pdf_common.py na backendu).
export function pracovniDnyMezi(startISO, endISO) {
  const start = new Date(startISO);
  const end = new Date(endISO);
  if (isNaN(start.getTime()) || isNaN(end.getTime()) || end <= start) return 0;
  let totalMs = 0;
  const cur = new Date(start);
  while (cur < end) {
    const denKonec = new Date(cur.getFullYear(), cur.getMonth(), cur.getDate() + 1);
    const usekKonec = denKonec < end ? denKonec : end;
    const den = cur.getDay();
    if (den !== 0 && den !== 6) {
      totalMs += usekKonec - cur;
    }
    cur.setTime(denKonec.getTime());
  }
  return totalMs / (1000 * 60 * 60 * 24);
}

// Stáhne PDF přes axios (aby prošly interceptory s API klíčem a JWT tokenem —
// obyčejný <a href> otevřený v nové záložce je čistá prohlížečová navigace
// bez custom hlaviček a middleware ho odmítne jako "Neplatný API klíč").
export async function stahniPdf(axiosInstance, url, filename) {
  const res = await axiosInstance.get(url, { responseType: 'blob' });
  const blobUrl = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(blobUrl);
}
